import React from 'react'
import { connect } from 'react-redux'
import { dataTypes, bindingTypes } from '@adalo/constants'
import { Field } from 'redux-form'
import classNames from 'classnames'

import { getLabel } from '../../../../utils/sources'
import { getParams } from '../../../../ducks/apps/params'
import { getSources, addBindings } from '../../../../ducks/recommender'
import { getDefaultDatasource } from '../../../../ducks/apps/datasources'
import MenuControl from '../../Inspect/Libraries/MenuControl'
import { WrappedBindableTextControl } from '../../../Shared/BindableTextControl'
import FilteringExtension from '../../DataBinding/FilteringFormExtension'
import { LinkMenu } from './Navigate'
import Params from './Params'
import { THEMES } from '../../../../constants'

const REPEAT_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'minute', label: 'Minute' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
]

const STOPPING_CRITERIA_OPTIONS = [
  { value: 'afterNumber', label: 'After number of times' },
  { value: 'endDate', label: 'End Date Reached' },
]

const ScheduleNotificationOptions = ({
  appId,
  componentId,
  objectId,
  actionId,
  field,
  userOptions,
  getLabel,
  reference,
  options,
  menuTheme,
  ...props
}) => {
  const role = reference ? 'listItem' : null
  const { audience } = options
  const showFilter =
    audience && audience.source && audience.source.dataType === dataTypes.LIST

  return (
    <div
      className={classNames(
        'action-item-form-options',
        'form-inspect-field-wrapper',
        'notifications-action-form'
      )}
    >
      <Field
        displayName="Recipient"
        component={MenuControl}
        name={`${field}.options.audience`}
        options={userOptions}
        getLabel={getLabel}
        menuTheme={menuTheme}
      />
      {showFilter ? (
        <FilteringExtension
          name={`${field}.options.audience.source.options.filter`}
          appId={appId}
          componentId={componentId}
          object={{ id: objectId }}
          binding={audience}
        />
      ) : null}
      <Field
        label="Title*"
        name={`${field}.options.title`}
        component={WrappedBindableTextControl}
        objectId={objectId}
        role={role}
        reference={reference}
        actionId={actionId}
      />
      <Field
        label="Body*"
        name={`${field}.options.body`}
        component={WrappedBindableTextControl}
        objectId={objectId}
        role={role}
        reference={reference}
        actionId={actionId}
      />
      <Field
        label="Scheduled Date (No Formatting)"
        name={`${field}.options.scheduledDate`}
        component={WrappedBindableTextControl}
        objectId={objectId}
        role={role}
        reference={reference}
        actionId={actionId}
        dataType="date"
      />
      <div className="library-inspect-menu-control">
        <p>Repeat Type</p>
        <Field
          name={`${field}.options.repeatType`}
          component={MenuControl}
          options={REPEAT_OPTIONS}
          menuTheme={menuTheme}
        />
      </div>
      {options?.repeatType && options.repeatType !== 'none' && (
        <>
          {options.repeatType === 'minute' ? (
            <>
              <Field
                label={`Repeat Every`}
                name={`${field}.options.repeatInterval`}
                component={WrappedBindableTextControl}
                objectId={objectId}
                role={role}
                reference={reference}
                actionId={actionId}
                type="number"
                placeholder="Enter number of minutes"
              />
              {/* For minute-based repeats, only show/use repeat interval */}
            </>
          ) : (
            <>
              {/* For daily/weekly/monthly, show explanatory message instead of editable interval */}
              <p style={{ fontSize: 12, color: '#666', marginTop: 8 }}>
                {`This notification will be repeated every 1 ${
                  options.repeatType === 'daily'
                    ? 'day'
                    : options.repeatType === 'weekly'
                    ? 'week'
                    : 'month'
                } starting from the first trigger.`}
              </p>
              <div className="library-inspect-menu-control">
                <p>Stopping Criteria</p>
                <Field
                  name={`${field}.options.stoppingCriteria`}
                  component={MenuControl}
                  options={STOPPING_CRITERIA_OPTIONS}
                  menuTheme={menuTheme}
                />
              </div>
              {options?.stoppingCriteria === 'afterNumber' && (
                <Field
                  label="Number of Times"
                  name={`${field}.options.afterNumber`}
                  component={WrappedBindableTextControl}
                  objectId={objectId}
                  role={role}
                  reference={reference}
                  actionId={actionId}
                  type="number"
                  placeholder="Enter number of times to repeat"
                />
              )}
              {options?.stoppingCriteria === 'endDate' && (
                <Field
                  label="End Date"
                  name={`${field}.options.endDate`}
                  component={WrappedBindableTextControl}
                  objectId={objectId}
                  role={role}
                  reference={reference}
                  actionId={actionId}
                  dataType="date"
                />
              )}
            </>
          )}
        </>
      )}
      <div className="library-inspect-menu-control">
        <p>Screen</p>
        <Field
          allScreens
          includeAssociated
          name={`${field}.options.screenId`}
          component={LinkMenu}
          appId={appId}
          componentId={componentId}
          menuTheme={THEMES.ACTION}
        />
      </div>
      <Params
        {...props}
        appId={appId}
        componentId={componentId}
        objectId={objectId}
        actionId={actionId}
        field={field}
        reference={reference}
        options={options}
      />
    </div>
  )
}

const mapStateToProps = (state, props) => {
  let { appId, componentId, objectId, actionId, reference, options } = props
  const datasource = getDefaultDatasource(state, appId)
  const { auth } = datasource
  const tableId = auth.table

  const userTypes = [
    { tableId, datasourceId: datasource.id, type: dataTypes.OBJECT },
    { tableId, datasourceId: datasource.id, type: dataTypes.LIST },
  ]

  const userOptions = addBindings(
    getSources(
      state,
      appId,
      componentId,
      objectId,
      userTypes,
      false,
      actionId,
      reference
    ),
    [bindingTypes.LIBRARY_PROP]
  )

  let screenId = options && options.screenId

  if (typeof screenId === 'object') {
    appId = screenId.appId
    screenId = screenId.screenId
  }

  return {
    userOptions,
    params: getParams(state, appId, screenId),
    getLabel: source => getLabel(state, source, appId, componentId),
  }
}

export default connect(mapStateToProps)(ScheduleNotificationOptions)
